module.exports = __webpack_public_path__ + "static/immunebytes-47e750687cc1fccf27228060026eb94d.svg";